import { Franchise } from '../api';

export function getLabelForFranchise(franchise: Franchise): string {
  switch (franchise) {
    case 'CHILD_0':
      return '0';
    case 'CHILD_100':
      return '100';
    case 'CHILD_200':
      return '200';
    case 'ADULT_300':
    case 'CHILD_300':
      return '300';
    case 'CHILD_400':
      return '400';
    case 'ADULT_500':
    case 'CHILD_500':
      return '500';
    case 'CHILD_600':
      return '600';
    case 'ADULT_1000':
      return "1'000";
    case 'ADULT_1500':
      return "1'500";
    case 'ADULT_2000':
      return "2'000";
    case 'ADULT_2500':
      return "2'500";
  }
}

export const adultFranchises: Franchise[] = [
  'ADULT_300',
  'ADULT_500',
  'ADULT_1000',
  'ADULT_1500',
  'ADULT_2000',
  'ADULT_2500',
];

export const childrenFranchises: Franchise[] = [
  'CHILD_0',
  'CHILD_100',
  'CHILD_200',
  'CHILD_300',
  'CHILD_400',
  'CHILD_500',
  'CHILD_600',
];

export function isAdultFranchise(franchise: Franchise): boolean {
  return adultFranchises.includes(franchise);
}
